/**
 * Utility functions for URL handling across the application
 */

/**
 * Get the base href from the DOM or default to empty string.
 * This handles apps deployed with different base hrefs (e.g., /accounting/, /demo/)
 */
export function getBaseHref(): string {
  const baseTag = document.querySelector('base');
  if (baseTag && baseTag.getAttribute('href')) {
    const baseHref = baseTag.getAttribute('href') || '/';
    return baseHref.endsWith('/') ? baseHref.slice(0, -1) : baseHref;
  }
  return '';
}

/**
 * Open a path in a new browser tab with proper base href handling.
 * @param path The path to open (e.g., '/exports')
 */
export function openInNewTab(path: string): void {
  const baseHref = getBaseHref();
  const fullUrl = baseHref ? `${baseHref}${path}` : path;
  window.open(fullUrl, '_blank');
}
